import api from '../../services/api';

/**
 * The dashboard's aggregates for the current filter.
 *
 * Not `api/dashboard/`, which is still the legacy's: that one fetches every
 * delivery in the range and counts them in Python. This one is grouped by
 * Postgres and answers with tens of rows.
 *
 * @param {object} params - `start_date`, `end_date`, `company`. Every filter
 *   the deliveries table supports is accepted too; the dashboard just does not
 *   send them yet.
 */
export const getDashboardMetricsRequest = (params) => {
  return api.get('api/dashboard/metrics/', { params });
};
